module.exports = __webpack_public_path__ + "static/media/notification_alert.feb29173.mp3";